export default __webpack_public_path__ + "static/media/times.e2925652.svg";